import { get } from "@ember/object"
import type { Planbook } from "@shared/models/planbook"
import type { User } from "@shared/models/user"

export default function defaultPlanbookContext(
  _payload,
  models: { planbook: Planbook; user: User }
) {
  return {
    planbookId: get(get(models, "planbook"), "id"),
    planbookTitle: get(get(get(models, "planbook"), "attributes"), "title"),
    userId: get(get(models, "user"), "id"),
  }
}
